import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const EditTestimonialFive = () => {

    const [testimonial, setTestimonial] = useState([]);
    const { id } = useParams();

    useEffect(() => {
        fetch(`https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/testimonial-five/${id}`)
            .then((res) => res.json())
            .then((info) => setTestimonial(info));
    }, [id]);

    const handleTestimonialSection = (event) => {
        event.preventDefault();
        const imageFive = event.target.imageFive.value;
        const personNameFive = event.target.personNameFive.value;
        const personTitleFive = event.target.personTitleFive.value;
        const descFive = event.target.descFive.value;

        const updatedTestimonial = {
            imageFive,
            personNameFive,
            personTitleFive,
            descFive
        };

        const url = `https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/testimonial-five/${id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(updatedTestimonial),
        })
            .then((res) => res.json())
            .then(() => {
                alert('Testimonial is updated');
            });
    };

    return (
        <>
         
            <div className="container vh-100 d-flex align-items-center justify-content-center">
                <section className="services-area" style={{ width: '100%' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6 col-md-8">
                                <h3 className="mb-4 text-center">Update Testimonial</h3>

                                <form className="contact-form" onSubmit={handleTestimonialSection}>
                                    <div className="form-group">
                                        <input
                                            className="form-control mb-3"
                                            name="imageFive"
                                            placeholder="imageFive URL"
                                            defaultValue={testimonial.imageFive}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            className="form-control mb-3"
                                            name="personNameFive"
                                            placeholder="Person Name"
                                            defaultValue={testimonial.personNameFive}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            className="form-control mb-3"
                                            name="personTitleFive"
                                            placeholder="Person Title"
                                            defaultValue={testimonial.personTitleFive}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            className="form-control mb-3"
                                            name="descFive"
                                            placeholder="descFiveription"
                                            defaultValue={testimonial.descFive}
                                            required
                                        />
                                    </div>

                                    <div className="text-center">
                                        <button className="btn btn-primary btn-lg">Update Testimonial</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default EditTestimonialFive;
